<template lang="pug">
  div(style='overflow:hidden')
    div(style='overflow:hidden;')
      div(:style='style2')
        div(ref='cheese',:style='style',@click='clickzors')
          div(v-if='!isSelected && !isIndirectlySelected')
            slot(name='default', v-bind:indirectTransform='indirectTransform')
          div(v-else)
              slot(name='selected',
                v-bind:screenContainer='renderTools.screenContainer',
                v-bind:container='container',
                v-bind:holder='holder',
                v-bind:bounds='bounds'
                v-bind:transform='transform',
                v-bind:isIndirectlySelected='isIndirectlySelected',
                v-bind:isSelected='isSelected',
                v-bind:indirectTransform='indirectTransform',
                v-bind:selected='isSelected')
</template>
<script>
import { mapState } from 'vuex';
import Overlay from '@edit/atoms/Overlay.vue';
import GetContainerBounds from './GetContainerBounds.vue';

export default {
  props:{
    holder:{
      type:Object,
      required:true
    },
    bounds:{
      type:Object,
      required:true
    },
    container:{
      type:Object,
      required:true
    },
    transform:{
      type:Object,
      required:true
    },
    parentTransform:{
      type:Object,
      required:true
    },
    renderTools:{
      type:Object,
      required:true
    },
    isSelected:{
      type:Boolean,
      default:false
    },
    isIndirectlySelected:{
      type:Boolean,
      default:false
    },
    context:{
      type:Object,
      default() {
        return {};
      }
    },
    partutil:{
      type:Object,
      required:true
    },
    updateContainerBounds:{
      type:Function,
      required:false
    }

  },
  components: {
    GetContainerBounds,
    Overlay,
  },
  data() {
    let zIndex = 20;
    let indirectTransform = this.transform;
    if (!isNaN(parseInt(this.transform.zIndex))) {
      zIndex = 20 + parseInt(this.transform.zIndex);
    }
    if (this.context.interactiveOverrideZindex) {
      zIndex = 20 + parseInt(this.context.interactiveOverrideZindex);
    }
    if (this.context.interactiveOverrideIndirectTransform) {
      indirectTransform = this.context.interactiveOverrideIndirectTransform;
    }
    return {
      zIndex,
      indirectTransform,
      pointerDown:false,
      pointerDownLong:false
    }
  },
  watch: {
    // TODO: watch for performance issues with this later
    'transform.transform': {
      handler(nv) {
        this.renderTools.addToRunBatch( () => {
        this.renderTools.addToRunBatch( () => {
          this.updateContainerBounds();
        });
        });
      },
      deep:true
    },
    isAdvancedMode:{
      handler(nv) {
        if (!nv) {
          this.holder.events().on('hammerpanstart', ({x,y}) => {
            this.dragStartX = x;
            this.dragStartY = y;
            this.lastDrag = {
              x,
              y
            }
            this.pointerDown = false;
            this.pointerDownLong = false;

            this.$emit('drag-start', this.updateContainerBounds, this.holder);
          });
          this.holder.events().on('hammerpanmove', ({deltaX,deltaY}) => {

            this.dragStartX += deltaX;
            this.dragStartY += deltaY;

            const dx = this.dragStartX - this.lastDrag.x;
            const dy = this.dragStartY - this.lastDrag.y;

            const unit = this.renderTools.screenToWorldWithOffset({x:0,y:0});
            let p = this.renderTools.screenToWorldWithOffset({
              x: dx,
              y: dy
            });
            let delta = {
              x: p.x - unit.x,
              y: p.y - unit.y
            }
            //delta = this.renderTools.screenToWorld(delta);

            this.transform.transform.pos.x += delta.x;
            this.transform.transform.pos.y += delta.y;

            this.renderTools.addToUpdateBatch(this.holder, this.transform.id);

            this.lastDrag.x = this.dragStartX;
            this.lastDrag.y = this.dragStartY;
          });
          this.holder.events().on('hammerpanend', () => {
            this.$emit('drag-end', this.updateContainerBounds, this.holder);
          });


        } else {
          this.holder.events().off('hammerpanstart');
          this.holder.events().off('hammerpanmove');

        }
      },
      immediate:true
    }
  },
  methods:{
    clickzors(event) {
      this.onSelect();
      return true;
    },
    onAddSelect() {
      if (!this.isSelected) {
        this.$emit('select-add', {
          transform:this.transform,
          container:this.container,
          bounds:this.bounds,
          holder:this.holder
        });
      } else {
        this.$emit('unselect', {
          transform:this.transform,
          container:this.container,
          bounds:this.bounds,
          holder:this.holder
        });
        if (this.indirectTransform.id !== this.transform.id) {
          this.$emit('unselect', {
            transform:this.indirectTransform,
            container:this.container,
            bounds:this.bounds,
            holder:this.holder
          });
        }
      }
    },
    onSelect() {
      if (!this.isSelected) {
        this.$emit('select', {
          transform:this.transform,
          container:this.container,
          bounds:this.bounds,
          holder:this.holder
        });
        /*
        if (this.indirectTransform.id !== this.transform.id) {
          this.$emit('select', {
            transform:this.indirectTransform,
            container:this.container,
            bounds:this.bounds,
            holder:this.holder
          });
        }
        */
      } else {
        this.$emit('select', {
          transform:this.transform,
          container:this.container,
          bounds:this.bounds,
          holder:this.holder
        });
        if (this.indirectTransform.id !== this.transform.id) {
          this.$emit('unselect', {
            transform:this.indirectTransform,
            container:this.container,
            bounds:this.bounds,
            holder:this.holder
          });
        }
      }
    }
  },
  computed:{
    width() {
      return Math.max(20, Math.max(
        Math.abs(this.bounds.p3.x - this.bounds.p1.x),
        Math.abs(this.bounds.p4.x - this.bounds.p2.x)
      ))

    },
    height() {
      return Math.max(20, Math.max(
        Math.abs(this.bounds.p3.y - this.bounds.p1.y),
        Math.abs(this.bounds.p4.y - this.bounds.p2.y)
      ))

    },
    overlayStyle() {
      return {
        'padding-top':this.height*2 + 'px',
      }
    },
    style() {
      const localPos = {
        x:-0.5,
        y:-0.5
      }

      const width = this.width; 
      const height = this.height;

      const pos = {
        x:(this.bounds.p1.x + this.bounds.p3.x)/2 + localPos.x * width,
        y:(this.bounds.p1.y + this.bounds.p3.y)/2 + localPos.y * height
      }
      return {
        position:'relative',
        //'pointer-events':this.context.hack ? 'none' : undefined,
        'pointer-events':'none',
        'z-index':this.zIndex,
        //'background-color':this.pointerDownLong ? '#fa4' : '#4af',
        //'background-color':'#4af',
        'background-color':(this.pointerDownLong ? '#4af' : 'transparent'),
        //opacity:this.pointerDown ? (this.pointerDownLong ? 1.0 : 0.5) : 0.0,
        //opacity:(this.pointerDownLong ? 1.0 : 0.0),
        border:this.pointerDown ? '1px solid blue' : '',
        left:pos.x + 'px',
        top:pos.y + 'px',
        width:width + 'px',
        cursor:'pointer',
        height:height + 'px'
      }
    },
    style2() {
      return {
        position: 'absolute',
        left: '0px',
        top: '0px',
        'pointer-events':'none',
        //'pointer-events': this.context.hack ? 'none' : undefined,
      }
    },
    ...mapState(['isAdvancedMode'])
  },
  mounted() {
    if (!this.context.hack) {

      const component =this.partutil.findComponentForTransform(this.transform);
      if (component.type !== 'camera') {
        this.holder.enableInteractive();
        this.holder.events().on('hammertap', () => {
          this.onSelect();
          this.pointerDown = false;
        });

        this.holder.events().on('hammerpress', () => {
          this.pointerDown = true;
          this.pointerDownLong = true;
        });
        this.holder.events().on('hammerpressup', () => {
          this.onAddSelect();
          this.pointerDown = false
          this.pointerDownLong = false;
        });
        this.holder.events().on('hammershortpress', () => {
          this.pointerDown = true
        });
        this.holder.events().on('hammershortpressup', () => {
          this.pointerDown = false
          this.pointerDownLong = false;
        });


      }
    }
  },
  beforeDestroy() {
    this.$emit("selection-change", {
      transform: this.transform,
      isSelected: false
    });
    this.holder.events().off('hammertap');
    this.holder.events().off('hammerpress');
    this.holder.events().off('hammerpressup');
    this.holder.events().off('hammershortpress');
  }
}
</script>
